module.exports = __webpack_public_path__ + "img/胶桶混合管图标.d2b0e45d.png";